// css
import "../../scss/pages/archive-post.scss";

// utils
import foundation from "../_utils/foundation";
foundation();

// npm
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// libs
import HeaderSideNav from "../_libs/HeaderSideNav";
import Post from "../_libs/Post";

document.addEventListener("DOMContentLoaded", () => {
	HeaderSideNav();
	Post();
	setTimeout(function () {
		document.querySelectorAll(".js-first-animation").forEach((element) => {
			element.classList.add("is-active");
		});
	}, 300);
	setTimeout(function () {
		document.querySelectorAll(".js-fv").forEach((element) => {
			element.classList.add("is-active");
		});
	}, 400);

	setTimeout(function () {
		const posts = document.querySelectorAll(".js-post");
		gsap.to(posts, {
			opacity: 1,
			y: 0,
			duration: 1.5,
			stagger: 0.25,
			ease: "power2.out",
			scrollTrigger: {
				trigger: ".js-post-trigger",
				start: "top bottom-=100",
				toggleActions: "play none none none",
			},
		});
	}, 550);
});
window.addEventListener("load", () => {});
